import React, { useState, useEffect, useRef } from 'react';
import {
    List, ListItem, ListItemIcon, Grid, Card, CardHeader, Link,
    TextField, Button, Box, Collapse, Alert, IconButton
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import dayjs from "dayjs";
import 'dayjs/locale/es-mx.js'
import jwt_decode from "jwt-decode";
import CloseIcon from '@mui/icons-material/Close';
import ReportTwoToneIcon from '@mui/icons-material/ReportTwoTone';

dayjs.locale('es-mx')

export default function TramitesListado() {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [esJefe, setEsJefe] = useState(false)
    const [esAsistente, setEsAsistente] = useState(false)
    const [esJefeCaja, setEsJefeCaja] = useState(false)
    const [usuario, setUsuario] = useState({
        id: '',
        password: ''
    })
    const [errorDocumentoXLSX, setErrorDocumentoXLSX] = useState(false)
    const [helperTextDocumentoXLSX, setHelperTextDocumentoXLSX] = useState('')

    const [openMensaje, setOpenMensaje] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [severity, setSeverity] = useState('error')
    const limpiar = useRef(null)    

    const documento = new FormData()

    const token = sessionStorage.getItem('token')
    let idResponsable = null
    let idEntidad = null
    let idEntidadSuperior = null

    if (token) {
        const decoded = jwt_decode(token);
        idResponsable = decoded.id
        idEntidad = sessionStorage.getItem('idEntidad')
        idEntidadSuperior = sessionStorage.getItem('idEntidad')
    }

    const handleDelete = async (registro) => {
        //console.log(`registro ${JSON.stringify(registro)}`)
       
        const resDelete = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/reporteTramites/borrarDocumento`, {
            method: "DELETE",
            headers: {
                "archivo": registro,
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil'),
                "identidad": idEntidad,
                "identidadsuperior": idEntidadSuperior
            }
        })
        if(resDelete.status===200){
            setSeverity('success')
        }
        else{
            if(resDelete.status===400)
                setSeverity('warning')
            else
                setSeverity('error')
        }
        const resDocumentos = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/reporteTramites/leerTramites`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil'),
                "identidad": idEntidad,
                "identidadsuperior": idEntidadSuperior
            }
        })

        const documentos = await resDocumentos.json()
        setFiles(documentos)
        const datosRespuesta = await resDelete.json()
        const message = datosRespuesta.message
        setMensaje(message)
        setOpenMensaje(true)
    }

    const obtenerReglas = (decoded) => {
        let reglas
        const perfilElegido = sessionStorage.getItem('perfilElegido')
        switch (perfilElegido) {
            case 'asistente':
                reglas = decoded.rulesAsistente
                break
            case 'investigador':
                reglas = decoded.rulesJefaturaArea
                break
            case 'coordinacion':
                reglas = decoded.rulesCoordinacion
                break
            case 'jefe':
                reglas = decoded.rulesJefatura
                break
            case 'administracion':
                reglas = decoded.rulesAdministracionProyecto
                break
            default:
                break
        }
        return reglas
    }

    const subirDocumento = async (event) => {
        event.preventDefault()
        setLoading(true)
        const archivo = new FormData();
        archivo.append('documento', documento.get('tramites'));
        const resUploadTramites = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadTramites`, {
            method: "POST",
            body: archivo,
            headers: {
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil'),
                "identidad": sessionStorage.getItem('idEntidad'),
                "identidadsuperior": sessionStorage.getItem('idEntidadSuperior')
            }
        })
        //console.log(`DATOS RESPUESTA ${resUploadTramites}`)
        const datosRespuesta = await resUploadTramites.json()
        const message = datosRespuesta.message
        setMensaje(message)
        if (resUploadTramites.status === 200) {
            setSeverity('success')
            const resDocumentos = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/reporteTramites/leerTramites`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil'),
                    "identidad": idEntidad,
                    "identidadsuperior": idEntidadSuperior
                }
            })

            const documentos = await resDocumentos.json()
            setFiles(documentos)
        }
        else
            setSeverity('error')
        setOpenMensaje(true)

        setLoading(false)
        if (limpiar.current)
            limpiar.current.reset()

    }

    const verificarReglas = (reglas) => {
        for (let i = 0; i < reglas.length; i++) {
            //console.log(`REGLA ${i} action ${reglas[i].action} subject ${reglas[i].subject}`)
            if (reglas[i].action === 'manage' && reglas[i].subject === 'planPresupuestal') {
                setEsJefe(true)
                return
            }
            if (reglas[i].action === 'asistente' && reglas[i].subject === 'division') {
                setEsAsistente(true)
                return
            }
            if (reglas[i].action === 'jefatura' && reglas[i].subject === 'caja') {
                setEsJefeCaja(true)
                return
            }
        }
    }
    useEffect(() => {
        (async () => {
            if (token) {
                const decoded = jwt_decode(token);
                let reglas = decoded.rules
                if (!reglas)
                    reglas = obtenerReglas(decoded)
                const idResponsable = decoded.id;
                idEntidad = sessionStorage.getItem('idEntidad')
                idEntidadSuperior = sessionStorage.getItem('idEntidadSuperior')
                //console.log(`idEntidad ${idEntidad}`)
                //console.log(`idEntidadSuperior ${idEntidadSuperior}`)
                const resUsuario = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/${idResponsable}`)
                const data = await resUsuario.json()
                setUsuario(data)
                verificarReglas(reglas)
                const resDocumentos = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/reporteTramites/leerTramites`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil'),
                        "identidad": idEntidad,
                        "identidadsuperior": idEntidadSuperior
                    }
                })

                const documentos = await resDocumentos.json()
                setFiles(documentos)
                setLoading(false)
            }           
        })();
    }, []
    )

    return (
        <>
            <Grid item xs={12} style={{ marginTop: 15 }}>
                <Card>
                    <CardHeader title='Consulta de Trámites' />
                    {loading ? (
                        'Cargando datos...'
                    ) : (

                        <List>
                            {files.map((file, index) => (
                                <ListItem key={index}>
                                    <ListItemIcon>
                                        <InsertDriveFileIcon />
                                    </ListItemIcon>
                                    <Link
                                        style={{ cursor: 'pointer' }}
                                        component={RouterLink}
                                        to="/tramites"
                                        state={{ nombreArchivo: file, fecha: dayjs(file.slice(9, 19)).format('DD MMMM YYYY'), anio: file.slice(9, 13) }}
                                    >
                                        {dayjs(file.slice(9, 19)).format('DD MMMM YYYY')}
                                    </Link>
                                    {esAsistente && (Number(idEntidad) === 1 || Number(idEntidad) === 2) && ( // Mostrar solo si es asistente
                                        <Button
                                            variant="contained"
                                            size="small"
                                            style={{ marginLeft: 5, backgroundColor: "darkred", color: "white" }}
                                            onClick={() => handleDelete(file)}
                                            disabled={loading}
                                        >
                                            Eliminar
                                        </Button>
                                    )}
                                </ListItem>
                            ))}
                            {files.length === 0 ? <ListItem key={1}>
                                    <ListItemIcon>
                                        <ReportTwoToneIcon />
                                    </ListItemIcon>
                                    Sin reportes que mostrar
                                    
                                </ListItem> :<></> }
                            
                        </List>
                    )}
                </Card>
            </Grid>
            {esAsistente && (Number(idEntidad) === 1 || Number(idEntidad) === 2) ?
                <Grid item xs={12} style={{ marginTop: 15 }}>
                    <Card>
                        <CardHeader title='Subir nuevo reporte (esta acción sustituye al reporte existente)' />
                        <Grid container justifyContent='stretch' spacing={5} style={{ padding: 5, position: 'fixed', top:'50%', width:'80%', zIndex: openMensaje ? 1000 : -1}}>
                            <Grid item xs={12} sm={12}>
                                <Box sx={{ width: '100%' }}>
                                    <Collapse in={openMensaje}>
                                        <Alert severity={severity}
                                            action={
                                                <IconButton
                                                    aria-label="close"
                                                    color="inherit"
                                                    size="small"
                                                    onClick={() => {
                                                        setOpenMensaje(false);
                                                    }}
                                                >
                                                    <CloseIcon fontSize="inherit" />
                                                </IconButton>
                                            }
                                            style={{ marginTop: 30 }}
                                        >
                                            {mensaje}
                                        </Alert>
                                    </Collapse>
                                </Box>
                            </Grid>
                        </Grid>
                        <form onSubmit={(e) => (subirDocumento(e))} ref={limpiar}>
                            <Grid container justifyContent='stretch' spacing={5} style={{ padding: 15 }}>
                                <Grid item xs={12} sm={8}>
                                    <TextField label={'Documento XLSX (Excel)'} id='documentoXLSX' required name='documentoXLSX' focused type='file' accept="application/pdf" helperText={helperTextDocumentoXLSX} error={errorDocumentoXLSX} onChange={async (event) => {
                                        documento.delete('tramites')
                                        const file = event.target.files[0]
                                        if (event.target.value) {
                                            if (event.target.value.endsWith(".XLSX") || event.target.value.endsWith(".xlsx")) {
                                                setHelperTextDocumentoXLSX('')
                                                setErrorDocumentoXLSX(false)
                                            }
                                            else {
                                                setHelperTextDocumentoXLSX('Formato de archivo no válido, se requiere un archivo Excel *.xlsx')
                                                setErrorDocumentoXLSX(true)
                                                return
                                            }
                                            setHelperTextDocumentoXLSX('')
                                            setErrorDocumentoXLSX(false)
                                        }

                                        documento.append('tramites', file)
                                    }} sx={{ width: '100%' }} />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Button variant='contained' color='primary' type='submit' disabled={errorDocumentoXLSX || loading}>
                                        Guardar
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Card>

                </Grid>
                : <></>

            }
        </>
    );
};